import styled, { createGlobalStyle } from "styled-components";

export const MedicationGlobalStyle = createGlobalStyle`
  body.calculadora {
    background: #f4efef;
  }
`;

export const Page = styled.main`
  --wine: #310204;
  --wine-light: #5a1116;
  --wine-soft: #f8eeee;
  --ink: #271d1e;
  --muted: #796b6c;
  --line: #e7dcdc;
  --paper: #ffffff;
  --warning: #a65b00;
  --warning-bg: #fff8e9;
  min-height: 100vh;
  color: var(--ink);
  font-family: Arial, Helvetica, sans-serif;
  padding: 32px clamp(16px, 4vw, 64px) 110px;

  * {
    box-sizing: border-box;
  }

  button,
  input,
  select,
  textarea {
    font: inherit;
  }

  button {
    cursor: pointer;
  }

  .hero,
  .workspace {
    width: min(1480px, 100%);
    margin: 0 auto;
  }

  .hero {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 24px;
    margin-bottom: 28px;
  }

  .brand {
    display: flex;
    align-items: center;
    gap: 16px;
  }

  .brand img {
    width: 150px;
    height: auto;
  }

  .hero h1 {
    color: var(--wine);
    font-size: clamp(2rem, 5vw, 3.4rem);
    line-height: 1;
    margin: 0 0 12px;
  }

  .hero p {
    color: var(--muted);
    font-size: 1rem;
    margin: 0;
    max-width: 760px;
  }

  .review-banner {
    flex: 0 0 auto;
    border: 1px solid #e5c678;
    background: #fff8e6;
    color: #7d5100;
    border-radius: 14px;
    padding: 12px 16px;
    font-size: 0.86rem;
    font-weight: 700;
    max-width: 320px;
  }

  .workspace {
    display: grid;
    grid-template-columns: minmax(0, 0.95fr) minmax(0, 1.05fr);
    gap: 24px;
    align-items: start;
  }

  .column {
    display: grid;
    gap: 20px;
  }

  .card {
    background: var(--paper);
    border: 1px solid var(--line);
    border-radius: 20px;
    box-shadow: 0 12px 34px rgba(49, 2, 4, 0.06);
    padding: clamp(18px, 3vw, 28px);
  }

  .card-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 12px;
    margin-bottom: 20px;
  }

  .card h2,
  .card h3 {
    margin: 0;
    color: var(--wine);
  }

  .card h2 {
    font-size: 1.12rem;
  }

  .card h3 {
    font-size: 1rem;
  }

  .step {
    display: inline-grid;
    place-items: center;
    width: 28px;
    height: 28px;
    margin-right: 8px;
    border-radius: 999px;
    background: var(--wine);
    color: #fff;
    font-size: 0.82rem;
  }

  .grid {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 14px;
  }

  .grid.three {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }

  .field {
    display: grid;
    gap: 7px;
  }

  .field.full {
    grid-column: 1 / -1;
  }

  .field label,
  .field-label {
    color: #4d4041;
    font-size: 0.88rem;
    font-weight: 700;
  }

  input,
  select,
  textarea {
    width: 100%;
    border: 1px solid #d9cbcc;
    border-radius: 12px;
    background: #fff;
    color: var(--ink);
    padding: 12px 13px;
    outline: none;
    transition: border-color 160ms ease, box-shadow 160ms ease;
  }

  textarea {
    min-height: 88px;
    resize: vertical;
  }

  input:focus,
  select:focus,
  textarea:focus {
    border-color: var(--wine);
    box-shadow: 0 0 0 3px rgba(49, 2, 4, 0.1);
  }

  input[type="checkbox"] {
    width: 18px;
    height: 18px;
    padding: 0;
    accent-color: var(--wine);
  }

  .check-grid {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 10px;
  }

  .check {
    display: flex;
    align-items: center;
    gap: 10px;
    border: 1px solid var(--line);
    border-radius: 12px;
    padding: 11px 12px;
    color: #514344;
    font-size: 0.86rem;
  }

  .profile-note,
  .subtle {
    color: var(--muted);
    font-size: 0.82rem;
  }

  .profile-note {
    margin-top: 12px;
  }

  .search {
    position: relative;
    margin-bottom: 14px;
  }

  .search input {
    padding-left: 42px;
  }

  .search-icon {
    position: absolute;
    left: 13px;
    top: 50%;
    transform: translateY(-50%);
    color: var(--muted);
    pointer-events: none;
  }

  .chips {
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
    margin-bottom: 14px;
  }

  .chip {
    border: 1px solid var(--line);
    background: #fff;
    color: var(--wine);
    padding: 8px 11px;
    border-radius: 999px;
    font-size: 0.78rem;
    font-weight: 700;
  }

  .chip.active {
    background: var(--wine);
    border-color: var(--wine);
    color: #fff;
  }

  .medication-list {
    display: grid;
    gap: 9px;
    max-height: 460px;
    overflow: auto;
    padding-right: 4px;
  }

  .medication-item {
    text-align: left;
    border: 1px solid var(--line);
    background: #fff;
    border-radius: 14px;
    padding: 13px 14px;
    display: grid;
    grid-template-columns: 1fr auto;
    gap: 5px 12px;
  }

  .medication-item strong {
    color: var(--ink);
  }

  .medication-item span {
    color: var(--muted);
    font-size: 0.78rem;
  }

  .medication-item .category {
    align-self: center;
    grid-row: 1 / span 2;
    grid-column: 2;
    color: var(--wine);
    font-weight: 700;
  }

  .medication-item.selected {
    border-color: var(--wine);
    background: var(--wine-soft);
    box-shadow: 0 0 0 2px rgba(49, 2, 4, 0.08);
  }

  .selected-medication {
    border-radius: 14px;
    background: var(--wine-soft);
    padding: 14px;
    margin-bottom: 14px;
  }

  .selected-medication strong {
    display: block;
    color: var(--wine);
    margin-bottom: 5px;
  }

  .selected-medication a {
    display: inline-block;
    margin-top: 9px;
    color: var(--wine);
    font-size: 0.82rem;
    font-weight: 700;
  }

  .dose-card {
    background: linear-gradient(145deg, var(--wine), #4f0c12);
    color: #fff;
    border: 0;
  }

  .dose-card h2 {
    color: #ead6d7;
    font-size: 0.85rem;
    letter-spacing: 0.08em;
    text-transform: uppercase;
  }

  .dose-main {
    display: flex;
    align-items: baseline;
    flex-wrap: wrap;
    gap: 8px 14px;
    margin: 14px 0 8px;
  }

  .dose-main strong {
    font-size: clamp(2.4rem, 7vw, 4.4rem);
    line-height: 1;
  }

  .dose-main span {
    color: #e5cfd0;
    font-size: 1.15rem;
  }

  .dose-card .subtle {
    color: #e5cfd0;
  }

  .status {
    border-radius: 999px;
    padding: 7px 11px;
    font-size: 0.75rem;
    font-weight: 800;
  }

  .status.pending {
    background: #fff0c9;
    color: #7d5100;
  }

  .status.ready {
    background: #dcf5e6;
    color: #146437;
  }

  .metric-grid {
    display: grid;
    grid-template-columns: repeat(3, minmax(0, 1fr));
    gap: 10px;
    margin-bottom: 16px;
  }

  .metric {
    background: #f7f2f2;
    border-radius: 13px;
    padding: 13px;
    text-align: center;
  }

  .metric span {
    display: block;
    color: var(--muted);
    font-size: 0.75rem;
    margin-bottom: 4px;
  }

  .metric strong {
    color: var(--wine);
    font-size: 1rem;
  }

  .prescription {
    border: 1px solid var(--line);
    border-radius: 14px;
    background: #fff;
    padding: 15px;
    white-space: pre-line;
    line-height: 1.55;
  }

  .button-row {
    display: flex;
    flex-wrap: wrap;
    gap: 10px;
    margin-top: 15px;
  }

  .button {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    border-radius: 11px;
    padding: 11px 14px;
    font-weight: 800;
    border: 1px solid var(--wine);
    background: var(--wine);
    color: #fff;
  }

  .button.secondary {
    background: #fff;
    color: var(--wine);
  }

  .button:disabled {
    border-color: #d9cece;
    background: #e8e1e1;
    color: #958889;
    cursor: not-allowed;
  }

  .alerts {
    display: grid;
    gap: 9px;
  }

  .alert {
    border-radius: 12px;
    padding: 11px 13px;
    display: flex;
    align-items: flex-start;
    gap: 9px;
    font-size: 0.84rem;
    line-height: 1.45;
  }

  .alert.warning {
    color: #724900;
    border: 1px solid #e8c36e;
    background: var(--warning-bg);
  }

  .alert.error {
    color: #8b1c25;
    border: 1px solid #efb5ba;
    background: #fff0f1;
  }

  .alert.info {
    color: #4e4142;
    border: 1px solid var(--line);
    background: #f8f5f5;
  }

  .empty {
    color: var(--muted);
    text-align: center;
    border: 1px dashed #d7c9ca;
    border-radius: 14px;
    padding: 32px 18px;
  }

  .success-message {
    margin-top: 12px;
    color: #126334;
    font-size: 0.84rem;
    font-weight: 700;
  }

  @media (max-width: 1050px) {
    .workspace {
      grid-template-columns: 1fr;
    }

    .hero {
      align-items: flex-start;
      flex-direction: column;
    }
  }

  @media (max-width: 640px) {
    padding: 20px 12px 104px;

    .hero h1 {
      font-size: 2rem;
    }

    .brand {
      align-items: flex-start;
      flex-direction: column;
    }

    .brand img {
      width: 145px;
    }

    .grid,
    .grid.three,
    .check-grid,
    .metric-grid {
      grid-template-columns: 1fr;
    }

    .card {
      border-radius: 16px;
      padding: 16px;
    }

    .medication-list {
      max-height: 390px;
    }

    .button {
      flex: 1 1 100%;
    }
  }
`;
